import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import NoteModel from "../../../model/note.model";
import NoteService from "../../../api/note/note.service";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmDialogComponent, ConfirmDialogModel} from "../../dialogs/confirm-dialog/confirm-dialog.component";
import UserService from "../../../api/user/user.service";

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.scss']
})
export class NoteComponent implements OnInit {
  @Input() note: NoteModel;
  @Output() deleted = new EventEmitter<NoteModel>();
  @Output() saved = new EventEmitter<NoteModel>();

  private updatedText;

  public editMode = false;

  public changeableByCurrentUser = false;

  public constructor(private noteService: NoteService, private dialog: MatDialog, private userService: UserService) {
  }

  ngOnInit() {
    const user = this.userService.getUserSnapshot();
    this.changeableByCurrentUser = user.roles.indexOf('ROLE_CRM_ADMIN') >= 0 || user.id == this.note.user.id;
    this.updatedText = this.note.text;
  }

  public delete() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Notiz löschen',
        message: 'Soll die Notiz wirklich gelöscht werden?'
      } as ConfirmDialogModel
    });
    dialogRef.afterClosed().subscribe(confirmed => {
      if(confirmed) {
         this.noteService.delete(this.note).subscribe(result => {
           if(result) {
             this.deleted.emit(this.note);
           }
         });
      }
    });
  }

  public save() {
    this.editMode = false;
    this.note.text = this.updatedText;
    this.noteService.update(this.note).subscribe(result => {
      this.saved.emit(result);
    });
  }

  public textChanged(event) {
    console.log(event.target);
    if(this.editMode) {
      this.updatedText = event.target.innerText;
    }
  }
}
